<template>
    <div>
        <slot name="superheader" v-bind:parentToggledRow="parentToggledRow">
        </slot>

        <v-card>
            <v-row v-for="row in rows" :key="rows.indexOf(row)">
                <span v-for="ipa in row" :key="row.indexOf(ipa)" >
                    <v-badge color="error" overlap :content="ipa.ipa_mac_count" :value="ipa.ipa_mac_count>1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn min-width="40px" width="50px" :class="compute_class(ipa)" v-on="on"><small>{{compute_digit(ipa)}}</small></v-btn>
                            </template>
                            <span>
                                {{ipa.ipa_mac_list}}<br/>
                                {{ipa.ipa_equ_list}}<br/>
                                {{parseInt(ipa.ipa_age_seconds)}} sec.
                            </span>
                        </v-tooltip>
                    </v-badge>
                </span>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';

export default {
    components: {
    },
    props: {
       loading: Boolean,
       level: Object,
       row: Object,
       childKey: {
           type: Number,
           default: function () {
               return null;
           }
       },
       callbacks: Object,
       columns: Array,
       nbCols: Number,
       nestedSlotNames: Array,
       options: Object
    },
    data: () => {
        return {
            rows: [],
            errors: [],
            _openedChildRows: [],
            parentToggledRow: {},
            maxAgeInSeconds: 7200,
        }
    },
    created() {
    },
    async mounted() {
      if ( this.level.toggledRow ) {
         this.parentToggledRow = this.level.toggledRow;
      }
      await this.refresh_rows(this.childKey);
    },

    methods: {
        /*
         * Retrieve the full record being toggled (open)
         * Need to be retrieve by sub-component
        */ 
        getToggledRow: function(key) {
            let _ret = false;
            let _len = this.rows.length;
            if ( this.level.options.uniqueKey && key>0 ) {
               for( var i=0; i<_len; i++) {
                  if ( this.rows[i][this.level.options.uniqueKey]==key) { return this.rows[i]; }
               }
            }
            return false;
        },

        async refresh_rows(key=null) {
            if ( typeof this.callbacks.refresh_rows == 'function' ) {
               var { errorinfos, api_response } = await this.callbacks.refresh_rows(key);
            } else {
               this.$emit('loading',true);
               var { errorinfos, api_response } = await this.$api.getRows(this.$router,this.level.api_code);
               this.$emit('loading',false);
            }
            this.errors = [ errorinfos ];
            if ( api_response.error==0 && api_response.rows ) {
               var raw_rows = api_response.rows;
            } else {
               var raw_rows = [];
            }
            let final_rows = [];
            let row = [];
            for ( var i=0;i<=raw_rows.length;i++ ) {
                if ( i % this.nbCols== 0 && i>0 ) {
                   final_rows.push(JSON.parse(JSON.stringify(row)));
                   row = [];
                } 
                row.push(raw_rows[i]);
            }
            this.rows = final_rows;
        },

        is_child_open(key) {
           let _pos = this._openedChildRows.indexOf(key);
           return _pos>=0;
        },

        toggle_childrow(key) {
            if ( this.is_child_open(key) ) {
               this._openedChildRows.splice(this._openedChildRows.indexOf(key),1);
            } else {
               this._openedChildRows.push(key);
               this.toggledRow = this.getToggledRow(key);
               this.$emit('childKey',this.level.level+1,key,this.toggledRow);
            }
            this.$refs.myTable.toggleChildRow(key);
        },

        compute_class(ipa) {
            if( ipa.ipa_is_network) {
                return 'grey'
            } else if (ipa.ipa_is_broadcast) {
                return 'grey'
            } else if (ipa.ipa_age_seconds>this.maxAgeInSeconds) {
                return 'warning'
            } else if (ipa.ipa_mac_count>0) {
                return 'primary'
            } else {
                return 'light'
            }
        },
        compute_digit(ipa) {
            let mask = 24;
            let cidrparts = ipa.net_cidr.split('/');
            if ( cidrparts.length==2 ) {
                mask = parseInt(cidrparts[1]);
            }
            if( ipa.ipa_address) {
                let digits = ipa.ipa_address.split('.');
                if (digits.length==4) {
                    if ( mask<16 ) {
                        return '.'+digits[1]+'.'+digits[2]+'.'+digits[3];
                    } else if (mask<24) {
                        return '.'+digits[2]+'.'+digits[3];
                    } else {
                    return '.'+digits[3];
                    }
                } else {
                    return '?'
                }
            }
        }
    },

    provide: function() {
        return {
            refresh_rows: this.refresh_rows
        }
    }

}
</script>